import * as Types from './types';

export const getCidadeLogadaSuccess = data => ({
  type: Types.LOAD_CIDADE_LOGADA,
  payload: data
});
